/* @flow */
/**
 * Internal dependencies
 */
import {
	VIDEO_LOADED,
	VIDEO_PLAY,
	VIDEO_RESET,
} from '../constants/action-types';

/**
 * Play/pause video
 */
export type VideoPlayAction = {
	type: typeof VIDEO_PLAY;
	payload: boolean;
};

export const play = ( payload: boolean ) : VideoPlayAction => {
	return {
		type: VIDEO_PLAY,
		payload,
	};
};

/**
 * Reset video state
 */
export type VideoResetAction = {
	type: typeof VIDEO_RESET;
	payload: boolean,
};

export const reset = ( resetLoaded: boolean = true ) => {
	return {
		type: VIDEO_RESET,
		payload: ! resetLoaded,
	};
};

/**
 * Loaded component
 */
export type VideoLoadedAction = {
	type: typeof VIDEO_LOADED;
	payload: boolean,
};

export const loaded = ( payload: boolean ) => {
	return {
		type: VIDEO_LOADED,
		payload,
	};
};



// WEBPACK FOOTER //
// ./src/actions/video.js